import { DASHBOARD_STATS_TAB_PRELOAD_ALL } from "@/lib/dashboard-query-options";
import { useMemo } from "react";
import { useAuthQuerySetup } from "./use-auth-query-setup";
import { useGovernmentDashboardStats } from "./use-government-dashboard-stats";

export function useGovernmentLicenseTypeFilterOptions() {
  const { isAuthSetupComplete } = useAuthQuerySetup();

  // Get the license type configurations for the government user's jurisdiction
  const { licenseTypeConfigsData, isJurisdictionsQueryLoading } =
    useGovernmentDashboardStats(
      isAuthSetupComplete,
      [], // Empty array to get all configurations
      DASHBOARD_STATS_TAB_PRELOAD_ALL,
    );

  const licenseTypeOptions = useMemo(() => {
    return (
      licenseTypeConfigsData?.map((config) => ({
        value: config.license_type_id,
        label: config.license_type_name,
      })) ?? []
    );
  }, [licenseTypeConfigsData]);

  return {
    licenseTypeOptions,
    isLoading: isJurisdictionsQueryLoading,
    error: null, // We'll handle errors in the main dashboard stats hook
  };
}
